// Generator ID (Strategia C rozszerzona): SŁOWO-XXX
// - Słowo z listy (2–6 znaków, [a-z0-9]) po uppercase.
// - Separator '-'.
// - 3 znaki Base32 (A-Z2-7) zwiększające entropię (~15 bitów) => ok. 400 * 32^3 ≈ 13M kombinacji.
// Zwiększa odporność na kolizje oraz enumerację względem pojedynczego słowa.

import { WORDS_PL as RAW } from './wordsPL.ts';
import { createE2ETestGameId, shouldUseE2ETestMarker } from './e2eTestData';

// Lista słów do wykluczenia (NSFW / niepożądane / potencjalnie problematyczne).
const BANNED = new Set<string>([
  'penis' // NSFW
]);

// Filtrowanie: 2–6 znaków, tylko a-z0-9, bez słów zabronionych, deduplikacja w wordsPL.ts już wykonana.
const WORDS_PL = RAW.filter(w => /^[a-z0-9]{2,6}$/.test(w) && !BANNED.has(w));

const BASE32 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';

function randInt(max: number) { return Math.floor(Math.random() * max); }
function pickWord(): string { return WORDS_PL[randInt(WORDS_PL.length)]; }
function randBase32(len: number) {
  let out = '';
  for (let i = 0; i < len; i++) out += BASE32[randInt(BASE32.length)];
  return out;
}

export function generateGameId(options?: { forceTestMarker?: boolean }): string {
  const useTestMarker = shouldUseE2ETestMarker({ force: options?.forceTestMarker });
  if (useTestMarker) return createE2ETestGameId({ force: true });
  if (WORDS_PL.length === 0) return randBase32(6); // awaryjny fallback – czysto losowy
  const word = pickWord().toUpperCase();
  const suffix = randBase32(3);
  return `${word}-${suffix}`;
}

// Walidator formatu (może być przydatny w join flow)
export function isValidGameId(id: string): boolean {
  // {3,5}: produkcyjne ID mają 3 znaki sufiksu, e2e używa 5 (patrz e2eTestData.ts).
  return /^[A-Z0-9]{2,6}-[A-Z2-7]{3,5}$/.test(id);
}
